import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const style: CSSResult = css`
  .col-layout {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  csc-carousel {
    --csc-carousel-column-gap-mobile: ${csSpacing.spacing08};

    @media (min-width: ${SCREENS.medium}) {
      --csc-carousel-column-gap-desktop: ${csSpacing.spacing08};
    }
  }

  .grid,
  .grid-2 {
    display: grid;
    column-gap: var(--csc-product-grid-column-gap, ${csSpacing.spacing08});
    row-gap: var(--csc-product-grid-row-gap, ${csSpacing.spacing08});
    grid-template-columns: 1fr;
  }

  @media (min-width: ${SCREENS.medium}) {
    .grid,
    .grid-2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: ${SCREENS.extraLarge}) {
    .grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
  }

  csc-base-product-tile {
    --csc-base-product-tile-border-width: ${csSpacing.spacing00};
    --csc-base-product-tile-list-border-width: ${csSpacing.spacing00};

  }
`
